import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'

const base = 'widget-integration'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Widget.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 200,
  text: $vm => $vm.$t('settings.sections.widget'),
  route: {
    name: `${base}`,
  },
  icon: 'icon-circle-code',
  permission: 'administer',
})
